export default __webpack_public_path__ + "static/media/office1-after1-1440w.a7705b2d.png";